import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import CheckboxInput from '../../common/components/checkbox-input'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import SummaryPrice from '../../common/components/summary-price'
import QueryString from 'query-string'
import QuoteNumber from '../../common/components/quote-number'
import Info from '../../common/components/info'
import { getQueryString, toCurrency, condition } from '../../common/util'
import { withProductData } from '../../common/modules/product-data'
import { withSubmission } from '../../common/modules/submission'
import { withFields } from '../../common/modules/fields'
import { withForm } from '../../common/modules/form'
import { withConfig } from  '../../common/modules/config'
import { withNavigation } from  '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { Table, Row, Cell, Alternate } from '../../common/components/summary-table'


export const formConfig = state => {
    const fields = state.fields;

    return {
        rules: {
        },
        predicates:{},
        options:{},
        inferred:{},
        transformOut: data => data
    }

}


@withForm(formConfig)
@withSubmission
@withFields
@withNavigation
@withRouteBlocker
@withConfig
@withProductData
@withScrollToTop
export default class extends React.Component<any, any> {

    componentWillMount(){

        const path = window.location.href;
        
        if(this.props.fields.referred){
            const newPath = path + '?status=referred'
            window.location.replace(newPath);
        }
        else if(this.props.fields.showPrice){
            const newPath = path + '?status=Quoted'
            window.location.replace(newPath);
        }
        else if(this.props.fields.indicativePrice){
            const newPath = path + '?status=indicativePrice'
            window.location.replace(newPath);
        }
        

        if(this.props.fields.declined || this.props.fields.referred){        
            this.props.actions.navigation.setCloseWarning(false);
            this.props.actions.navigation.disableRoutes([
                "/step-1",
                "/step-2",
                "/step-3",
                "/step-4"
            ])
        }

            if(this.props.fields.declined){
                     this.props.actions.navigation.changeRoute("/declined");
        }
    }
   
  
    render() {
        const fields = this.props.fields

        return (   
            <div className="row">
                <StepTitle>Here's The Cover You Requested</StepTitle>	
                <QuoteNumber />
                
                <StepBlock className="mt-4"><b>Your Protection Overview</b></StepBlock>
                <Table>
                    <Row highlight>
                    {condition(
                            fields.coverType == "PREMIER", <Cell highlight>Contents - Premier Cover</Cell>,
                            fields.coverType == "BASIC", <Cell highlight>Contents - Basic Cover</Cell>
                        )} <Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Sum insured</Cell>
                        <Cell>${ toCurrency(fields.contentsSumInsured) }</Cell>
                    </Row>
                    <Row>
                        <Cell>Excess <Info title="Did you know?" message="You may be eligible for an excess waiver if your building is also insured by CHU. Please refer to the PDS for more information."/></Cell>
                        <Cell>${ toCurrency(fields.contentsExcess) }</Cell>
                    </Row>
                    <Row>
                        <Cell>Accidential Damage</Cell>
                        <Cell>
                            {condition(
                                fields.coverType == "PREMIER", <span>Included</span>,
                                fields.accidentalDamageCoverage == true, <span>Selected</span>,
                                fields.accidentalDamageCoverage == false, <span>Not Insured</span>
                            )}
                        </Cell>
                    </Row>
                    <Row>
                        <Cell>Contents temporarily removed from the home unit</Cell>
                        <Cell>
                            {condition(
                                fields.coverType == "PREMIER", <span>Included</span>,
                                fields.portableContentsCoverage == true, <span>Selected</span>,
                                fields.portableContentsCoverage == false, <span>Not Insured</span>
                            )}
                        </Cell>
                    </Row>
                    <Row highlight>
                        <Cell>Legal Liability</Cell><Cell></Cell>
                    </Row>
                    <Row>
                        <Cell>Sum insured</Cell>
                        <Cell>${toCurrency(fields.liabilitySumInsured)}</Cell>
                    </Row>
                </Table>
                <SummaryPrice
                    referred = { fields.referred }
                    totalPayable = { fields.totalPayable }
                    basePremium = { fields.basePremium }
                    levies = { fields.levies }
                    gst = { fields.gst }
                    stampDuty = { fields.stampDuty }
                    adminFee = { fields.adminFee }
                    brokerFee = { fields.brokerFee }
                    commission = { fields.commission }
                    commissionGst = { fields.commissionGst }
                    summaryText = { fields.summaryText }
                    actions = { this.props.actions }
                    referrals = {fields.referrals}
                    indicativePrice = {fields.indicativePrice}
                    indicativePriceText = {fields.indicativePriceText}
                />

                <Button.Container show={!fields.referred}>
                    <Button.Back route="/step-4" />
                    <Button.Save onClick={ this.save.bind(this) } />
                    <Button.BuyNow onClick={ this.proceed.bind(this) } />
                </Button.Container>
            </div>
        )
    }


    save(){
        this.props.actions.submission.save("/step-5", [
            formConfig
        ])
    }


    proceed(){
        this.props.actions.navigation.changeRoute("/step-6")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/step-5.tsx